export const parseGoogleWebAdConfig = ({ client, slot }) => {
  if (typeof client !== 'string') {
    return {
      isEnabled: false,
      reason: 'missing_ad_client',
    };
  }

  if (typeof slot !== 'string') {
    return {
      isEnabled: false,
      reason: 'missing_ad_slot',
    };
  }

  const trimmedClient = client.trim();
  const trimmedSlot = slot.trim();

  if (!trimmedClient) {
    return {
      isEnabled: false,
      reason: 'empty_ad_client',
    };
  }

  if (!trimmedSlot) {
    return {
      isEnabled: false,
      reason: 'empty_ad_slot',
    };
  }

  if (!trimmedClient.startsWith('ca-pub-')) {
    return {
      isEnabled: false,
      reason: 'invalid_web_adsense_client',
    };
  }

  return {
    isEnabled: true,
    client: trimmedClient,
    slot: trimmedSlot,
  };
};
